const enabled = process.env.NODE_ENV !== "production";

const log = {
  debug: (...args) => enabled && console.debug(...args),
  warn: (...args) => enabled && console.warn(...args),
};

export default log;
